module.exports = __webpack_public_path__ + "static/media/2_pl.7911fa6c.png";